import { render } from "./Pacient.vue?vue&type=template&id=2b9c9a69&scoped=true"
import script from "./Pacient.vue?vue&type=script&lang=js"
export * from "./Pacient.vue?vue&type=script&lang=js"

import "./Pacient.vue?vue&type=style&index=0&id=2b9c9a69&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9c9a69"]])

export default __exports__